import React from "react";
import FullCourse from "./FullCourse";
import MiniCourse from "./MiniCourse";
import itemFilter from "./itemFilter";

const CourseList = function FullCourseList(props) {

    /*
    const itemFilter = (item)=>{
        if ( props.namefilter ) {
            if ( !item.literal.toLowerCase().includes(props.namefilter.toLowerCase() ) ) return false;
        }
        if ( props.coursefilter ) {
            if ( !item.code.includes( props.coursefilter ) ) return false;
        }
        if ( props.endorsementfilter ) {
            let hasEndorsement = false;
            for ( let x in item.endorsements ) {
                let thisEndorsement = item.endorsements[x];
                if ( thisEndorsement.endorsement_code.includes( props.endorsementfilter) ) hasEndorsement = true;
                if ( !hasEndorsement && thisEndorsement.endorsement.literal.includes( props.endorsementfilter.toUpperCase() ) ) hasEndorsement = true;
            }
            if ( !hasEndorsement ) return false;
        }
        return true;
    };
     */

    if ( props.subject==="" ) return <div className="has-text-centered notification is-info">No Courses Found</div>

    if ( props.subject === "all" || props.subject === "all-meet" || props.subject === "all-nomeet" ) {
        let totalSubjects = props.subjects.length;
        let groups = props.subjects.map( (item,i)=>{

            var filteredCourses = [];
            if ( props.courses[ item.code ] ) {
                filteredCourses = props.courses[ item.code ].filter(item=>itemFilter(item, props) );
            }
            if ( filteredCourses.length === 0 ) return '';
            return (
                <div key={i} className="subjectGroup">

                    <div id={"subjectsection_" + i} className="sectionanchor is-invisible">{item.code} Section</div>
                    <div className="columns">
                        <div className="column is-10">
                            <div className={"title is-" + (props.view==="expanded" ? 2:4) }>
                        {item.longLiteral} ({item.code})
                            </div>
                        </div>
                        {/* { props.view === "expanded" ?
                        <div className="column is-2 has-text-right">
                            { i > 0 ? <span><a href={"#subjectsection_" + (i-1)}>Previous</a> | </span>: '' }
                            { i < (totalSubjects-1) ? <a href={"#subjectsection_" + (i+1)}>Next</a> : '' }
                        </div>
                            : '' } */}
                    </div>
                    <hr />

                        {
                            filteredCourses.length ?
                                filteredCourses.map((item, key) => {
                                    return (
                                        props.view === "expanded" ?
                                            <FullCourse key={key} {...item} />
                                            :
                                            <MiniCourse key={key} {...item} />
                                    )
                                }) : <div data-err="e1">No Courses Found</div>
                        }

                </div>
            )



        })
        return groups;
    } else {

        var filteredCourses = []
        if ( props.courses[ props.subject] ) {
            filteredCourses = props.courses[props.subject].filter(item => itemFilter(item, props));
        }
        return (
            filteredCourses.length ?
                filteredCourses.map((item, key) => {
                return (
                        props.view === "expanded" ?
                        <FullCourse key={key} datayear={props.datayear} {...item} />
                        :
                        <MiniCourse key={key} {...item} />

                    )
                })
            :
                <div className="has-text-centered notification is-info">No Courses Found</div>
        )
    }
}

export default CourseList;
